import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { BaseText } from '../../common/BaseText';
import { IconTouchable } from '../../common/IconTouchable';
import { CheckBox, ICheckBoxProps } from '../../common/CheckBox';
import {
  Category,
  SubCategory,
} from '@models/Tutorials/CategoryModel';
import { IFilterSectionItemProps } from './FilterSectionItem';

const Container = styled(View)({
  flexDirection: 'row',
  justifyContent: 'flex-start',
});

const Text = styled(BaseText)({
  flexShrink: 1,
  pl: '$5',
  color: '$heading800',
  variant: 'text.small',
});

const CountText = styled(BaseText)({
  flexGrow: 1,
  width: 40,
  px: '$2',
  color: '$text200',
});

const Placeholder = styled(View)({
  size: 20,
});

interface IFilterItemProps
  extends Omit<IFilterSectionItemProps, 'item'>,
    Pick<ICheckBoxProps, 'onValueChange' | 'value'> {
  item: Category | SubCategory;
  count?: number;
}

export const FilterItem = observer(
  ({
    item,
    count,
    onChangeValue,
    withPreSelection,
    ...props
  }: IFilterItemProps) => {
    function onCategoryValueChange(i: any, value: boolean) {
      onChangeValue(i, value);
    }

    const isExpandable = item.children.length > 0;

    const isSelected = withPreSelection
      ? item.isPreselected
      : item.isSelected;

    const countText = typeof count !== 'undefined' && `(${count})`;

    const arrowIconName = item.isExpanded
      ? 'small-arrow-up-light'
      : 'small-arrow-down-light';

    return (
      <Container>
        <CheckBox
          hitSlop={10}
          value={isSelected}
          onValueChange={(value) =>
            onCategoryValueChange(item, value)
          }
          {...props}
        />
        <Text numberOfLines={1}>{item.name}</Text>
        <CountText>{countText}</CountText>

        {isExpandable ? (
          <IconTouchable
            onPress={item.toggleIsExpanded}
            name={arrowIconName}
          />
        ) : (
          <Placeholder />
        )}
      </Container>
    );
  },
);
